module.exports = __webpack_public_path__ + "static/media/0021.0e3472a6.png";